import { type SupportReplyBody, type SupportTicket, type SupportTicketPage } from '@/contracts';

import { authenticated } from '../auth-client';
import { API_PREFIX } from '../http';

export const supportEndpoints = {
  /**
   * The support inbox, one status at a time and cursor-paginated: `status` is one of
   * the three tabs, `cursor` the `nextCursor` of the page before.
   */
  supportTickets(params: Record<string, string> = {}) {
    const query = new URLSearchParams(params).toString();
    return authenticated<SupportTicketPage>(
      `${API_PREFIX}/admin/support/tickets${query ? `?${query}` : ''}`,
    );
  },

  /** One ticket with its whole thread, oldest message first. */
  supportTicket(ticketId: string) {
    return authenticated<SupportTicket>(`${API_PREFIX}/admin/support/tickets/${ticketId}`);
  },

  /** A team reply. The ticket comes back `answered`, with the new message appended. */
  replyToSupportTicket(ticketId: string, body: SupportReplyBody) {
    return authenticated<SupportTicket>(`${API_PREFIX}/admin/support/tickets/${ticketId}/replies`, {
      method: 'POST',
      body,
    });
  },

  /** Closes the ticket. No body: closing is not a reply and carries no reason. */
  closeSupportTicket(ticketId: string) {
    return authenticated<SupportTicket>(`${API_PREFIX}/admin/support/tickets/${ticketId}/close`, {
      method: 'POST',
    });
  },
};
